import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
import routes from "./routes";
import { displayNotification } from "@/common/notification";
import {
  CHECK_AUTH
} from "../store/actions.type";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: "active"
});

router.beforeEach(async (to, from, next) => {

  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const requiresAccess = to.matched.some(x => x.meta.requiresAccess)

  console.log(requiresAccess)

  if (requiresAuth || requiresAccess) {
    await store.dispatch(CHECK_AUTH)
  }
  
  const currentUser = store.getters.currentUser
  const isAuthenticated = store.getters.isAuthenticated

  
  const paths = to.fullPath.split('/')

  let canUserAccessRoute = !requiresAccess

  if (isAuthenticated && requiresAccess) {
    // Check base path segment for access permissions
    canUserAccessRoute = store.getters.currentUser.access.indexOf(paths[1]) !== -1

    // check if user is trying to update self
    // users/update/<user_id>
    if (paths[3] === currentUser.id) {
      canUserAccessRoute = true
    }
  } 

  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (requiresAuth && isAuthenticated && canUserAccessRoute) {
    next()
  } else if (requiresAuth && isAuthenticated && !canUserAccessRoute) {
    displayNotification('You don\'t have access to this page', 'warning')
    next('/dashboard')
  } else {
    next()
  }
})

export default router;
